import { H4, styled, withStyle } from '@olxeu-jobs/ui';

export const CardWrapper = styled<'article', { $compact: boolean | undefined }>(
  'article',
  ({ $theme, $compact }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.space[16],
    backgroundColor: $theme.colors['background-global-primary'],
    borderRadius: $theme.radii[4],
    padding: $theme.space[16],
    ...($compact && {
      flexDirection: 'row',
      alignItems: 'center',
    }),
  }),
);

export const VisualContentWrapper = styled<'div', { $compact: boolean | undefined }>(
  'div',
  ({ $theme, $compact }) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    ...(!$compact && {
      marginLeft: `-${$theme.space[16]}`,
      marginRight: `-${$theme.space[16]}`,
      marginTop: `-${$theme.space[16]}`,
    }),
  }),
);

export const ContentWrapper = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[8],
  overflow: 'hidden',
}));

export const ParamWrapper = styled('div', ({ $theme }) => ({
  ...$theme.typography.p4,
  display: 'flex',
  width: '100%',
}));

export const ParamContent = styled('span', () => ({
  flex: '0 1 auto',
  marginLeft: '.33em',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const Title = withStyle(H4, () => ({
  width: '100%',
  overflow: 'hidden',
  marginBottom: 0,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const LogoWrapper = styled<'div', { $compact: boolean | undefined }>(
  'div',
  ({ $theme, $compact }) => ({
    boxSizing: 'content-box',
    right: $theme.space[16],
    bottom: `-${$theme.space[12]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    aspectRatio: '4/3',
    backgroundColor: $theme.colors['background-global-primary'],
    overflow: 'hidden',
    border: `1px solid ${$theme.colors['borders-global-tertiary']}`,
    borderRadius: $theme.radii[4],
    flex: '0 0 auto',
    ...(!$compact && {
      position: 'absolute',
    }),
  }),
);

export const LoaderWrapper = styled('div', {
  position: 'relative',
  flex: 1,
});
